export default{
  // publicUrl : 'http://192.168.0.123:8081/dixcel' ,
  publicUrl : 'http://api.dixcel.cn/dixcel' ,
  // publicUrl : 'http://tz.s1.natapp.cc/dixcel' ,
  // publicUrl : 'http://localhost:8081/dixcel'
  // publicUrl : 'http://api-test.dixcel.cn/dixcel'
}

